import React, {useEffect} from 'react'
import {useParams, useLocation} from 'react-router-dom'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PageLoader from '../../components/page-loader'
import useEinstein from '@salesforce/retail-react-app/app/hooks/use-einstein'
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import Optimizely from '../../components/optimizely'
import {MAX_CACHE_AGE_CMS, STALE_WHILE_REVALIDATE_M} from '../../constants'
import {useOptimizelyPage} from '../../hooks/use-optimizely-page'
import PageNotFound from '../page-not-found'

const ContentPage = () => {
    const einstein = useEinstein()
    const {res} = useServerContext()
    const {pathname} = useLocation()
    const {pageName} = useParams()

    if (res) {
        res.set(
            'Cache-Control',
            `s-maxage=${MAX_CACHE_AGE_CMS}, stale-while-revalidate=${STALE_WHILE_REVALIDATE_M}`
        )
    }

    // Remove .html from the page name to get the content key
    const contentKey = pageName?.replace('.html', '') || ''

    // Request content from Optimizely based on the page name
    const {data: optimizelyData, isLoading: isOptimizelyLoading} = useOptimizelyPage(contentKey)

    useEffect(() => {
        einstein.sendViewPage(pathname)
    }, [pathname, einstein])

    if (isOptimizelyLoading) {
        return (
            <Box data-testid="content-page">
                <PageLoader />
            </Box>
        )
    }

    // Check if CMS content exists - if not, show 404
    const pageContent = optimizelyData?.page || optimizelyData
    const hasContent = pageContent?.items?.length > 0 || pageContent?.Content?.items?.length > 0

    // Render PageNotFound directly (not throw) to keep header/footer
    if (!hasContent) {
        return <PageNotFound />
    }

    // SEO is now handled by the Optimizely component using CMS page data
    // (MetaTitle, MetaDescription, CanonicalUrl, OpenGraphTags, ExcludeFromSitemap)
    return (
        <Box data-testid="content-page">
            <Optimizely content={pageContent} isLoading={isOptimizelyLoading} />
        </Box>
    )
}

export default ContentPage
